import { render } from "./InnovationArea.vue?vue&type=template&id=fb26155e"
import script from "./InnovationArea.vue?vue&type=script&lang=js"
export * from "./InnovationArea.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__